"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertOrcadNetlistToSchematic = convertOrcadNetlistToSchematic;
exports.getSchematicFromOrcadParseResult = getSchematicFromOrcadParseResult;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
function convertOrcadNetlistToSchematic(netlist, designId = 'orcad-netlist') {
    const warnings = [];
    const modules = [];
    const moduleMap = new Map();
    if (netlist.placement?.components) {
        for (const component of netlist.placement.components) {
            for (const place of component.places) {
                const transform = {
                    angle: 0,
                    mirrored: [false, false],
                };
                const module = {
                    ref: place.refdes,
                    footprintRef: component.name,
                    componentRef: component.name,
                    center: [0, 0],
                    layer: 'F',
                    transform,
                    name: place.refdes,
                    pinNets: {},
                    drawProperties: {},
                };
                modules.push(module);
                moduleMap.set(place.refdes, module);
            }
        }
    }
    const nets = {};
    if (netlist.network?.nets) {
        for (const net of netlist.network.nets) {
            const connections = [];
            for (const pin of net.pins ?? []) {
                const connection = {
                    moduleRef: pin.referenceDesignator,
                    moduleName: pin.referenceDesignator,
                    pinRef: pin.pin,
                };
                connections.push(connection);
                const module = moduleMap.get(pin.referenceDesignator);
                if (module) {
                    module.pinNets[pin.pin] = net.name;
                }
                else {
                    warnings.push(`Net '${net.name}' references unknown module '${pin.referenceDesignator}'`);
                }
            }
            nets[net.name] = {
                name: net.name,
                connections,
            };
        }
    }
    const schematic = {
        modelType: 'schematic',
        designId,
        sourceFile: 'orcad-netlist',
        sheetIndex: 0,
        layerSet: 'default',
        drawings: {},
        edges_bbox: { minx: 0, miny: 0, maxx: 0, maxy: 0 },
        initial_zoombox: { minx: 0, miny: 0, maxx: 0, maxy: 0 },
        nets,
        modules,
        ports: {},
        metadata: {
            title: netlist.description?.title ?? 'OrCAD Netlist Import',
            revision: netlist.description?.revision ?? '',
            company: netlist.description?.organization ?? '',
            date: netlist.description?.date ?? new Date().toISOString().split('T')[0],
        },
        warnings,
    };
    return { schematic, warnings };
}
function getSchematicFromOrcadParseResult(parseResult, designId) {
    if (parseResult.processingResults.severity === sigma_engine_shared_1.BoundaryLevel.Error) {
        return undefined;
    }
    if (!parseResult.netlist.network?.nets?.length) {
        return undefined;
    }
    return convertOrcadNetlistToSchematic(parseResult.netlist, designId);
}
//# sourceMappingURL=orcadNetlistToSchematic.js.map